import { render } from "./add_diabetes_procedures_modal.vue?vue&type=template&id=b42d2bde&scoped=true"
import script from "./add_diabetes_procedures_modal.vue?vue&type=script&lang=js"
export * from "./add_diabetes_procedures_modal.vue?vue&type=script&lang=js"

import "./add_diabetes_procedures_modal.vue?vue&type=style&index=0&id=b42d2bde&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b42d2bde"]])

export default __exports__